import React, { useCallback, useRef, useState, useEffect } from 'react';
import { ModelFilterAccordionSectionContent, ModelFilterAccordionSectionPanel, ModelFilterAccordionSectionPanelContent, StyledButton, Wrapper, StyledText, TextWrapper, StyledIcon, CarlineGroupAndAmountWrapper, ChosenModelsWrapper, CarlineGroupCheckboxes, AllModelsCheckbox, } from '../styles/ModelFilter.styles';
import { noop, setPanelHeight } from '../utils/utils';
import CheckboxSimple from './CheckboxSimple';
import { formatCount } from '../../../utils';
import { useServicesContext } from '../../../context';
import { useI18n } from '@oneaudi/i18n-context';
import { trackClicks } from '../tracking';
import { useApplyFilters, useFilterData } from '../FilterContextHooks';
import { ModelImage } from './ModelImage';
import { FilterContext } from '../FilterContext';
import { DynamicComponent, dynamicStylingHelper, DynamicThemeProviderWrapper, handleChangeAllCarlineModels, } from '../../utils';
import { Icon, Tag, Text } from '@oneaudi/unified-web-components';
import styled from 'styled-components';
import { SYS_COLOR_SURFACE_NEUTRAL_100_LIGHT } from '@oneaudi/unified-web-common';
import { SYS_BREAKPOINT_LG, SYS_COLOR_SURFACE_NEUTRAL_100_DARK, SYS_SPACE_FIXED_200, } from '@oneaudi/unified-web-alpha-common';
export const ModelFilterAccordionSection = ({ carlineGroup, carlineGroupName, carlineGroupCheckboxMembers, carlineGroupPhoto, carlineNames, filterCategory, group, layoutWidth, nthChild, visibleIn, open, onToggle = noop, onKeyDown = noop, toggleRef, }) => {
    const filterData = useFilterData();
    const applyFilters = useApplyFilters();
    const i18nCarlineGroupName = useI18n({
        id: `nemo.sc.filter.filtergroups.carline.${carlineGroup}`,
        defaultMessage: carlineGroup,
    });
    const modelsLabel = useI18n({
        id: `nemo.sc.filter.filtergroups.carline.models`,
        defaultMessage: 'models',
    });
    const chosenModelLabel = useI18n({
        id: `nemo.sc.filter.filtergroups.carline.chosenModel`,
        defaultMessage: 'model chosen',
    });
    const chosenModelsLabel = useI18n({
        id: `nemo.sc.filter.filtergroups.carline.chosenModels`,
        defaultMessage: 'models chosen',
    });
    const carlineGroupPhotoNotAvailableText = useI18n({
        id: `nemo.sc.filter.filtergroups.carline.imageNotFoundText`,
        defaultMessage: 'No image available',
    });
    const context = React.useContext(FilterContext);
    const trackingService = useServicesContext().getAdditionalService('audi-tracking-service');
    const localeService = useServicesContext().getAdditionalService('gfa:locale-service');
    const locale = `${localeService.language}-${localeService.countryCode}`;
    const panelId = `${carlineGroup}__panel`;
    const panelRef = useRef(null);
    const contentRef = useRef(null);
    const sectionRef = useRef(null);
    const [carlineGroupItems, setCarlineGroupItems] = useState();
    const [allCarlineModelsAreChecked, setAllCarlineModelsAreChecked] = useState(false);
    const handleToggle = useCallback(() => {
        onToggle(!open);
        const trackingEventName = open
            ? 'vtp filter - click on category - close accordion'
            : 'vtp filter - click on category - open accordion';
        trackClicks(trackingService, trackingEventName, `${i18nCarlineGroupName} (${countAllCarsOfCarline()})`, 'icon', filterCategory, false);
    }, [open, onToggle]);
    useEffect(() => {
        if (contentRef.current && panelRef.current) {
            setPanelHeight(panelRef.current, `${contentRef.current.scrollHeight}px`);
            if (typeof window !== 'undefined') {
                window.requestAnimationFrame(() => {
                    if (panelRef.current && contentRef.current) {
                        setPanelHeight(panelRef.current, open ? `${contentRef.current.scrollHeight}px` : '0px', true);
                    }
                });
            }
        }
    }, [open]);
    useEffect(() => {
        const carlineGroupItemsArray = [];
        carlineGroupCheckboxMembers.forEach((carlineGroupCheckboxMember) => {
            const carlineGroupCheckboxMemberData = group.items.find((item) => item.itemHeadline === carlineGroupCheckboxMember);
            if (carlineGroupCheckboxMemberData)
                carlineGroupItemsArray.push(carlineGroupCheckboxMemberData);
        });
        setCarlineGroupItems(carlineGroupItemsArray);
    }, [group.items]);
    useEffect(() => {
        if (filterData) {
            let allAvailableCarlineGroupMembersAreSelected = true;
            carlineGroupCheckboxMembers.forEach((carline) => {
                const carlineFilterData = filterData.groups.carline.members[carline];
                if ((carlineFilterData === null || carlineFilterData === void 0 ? void 0 : carlineFilterData.count) > 0 && !(carlineFilterData === null || carlineFilterData === void 0 ? void 0 : carlineFilterData.active))
                    allAvailableCarlineGroupMembersAreSelected = false;
            });
            setAllCarlineModelsAreChecked(allAvailableCarlineGroupMembersAreSelected);
        }
    }, [filterData]);
    const countSelectedCars = useCallback(() => {
        var _a, _b, _c;
        const appliedFilters = filterData === null || filterData === void 0 ? void 0 : filterData.filterOptions;
        const carlineGroupData = appliedFilters === null || appliedFilters === void 0 ? void 0 : appliedFilters[carlineGroup];
        const amountSelectedFilters = (carlineGroupData === null || carlineGroupData === void 0 ? void 0 : carlineGroupData.allSelected)
            ? (_b = (_a = carlineGroupData === null || carlineGroupData === void 0 ? void 0 : carlineGroupData.selectedFilter[0]) === null || _a === void 0 ? void 0 : _a.remove) === null || _b === void 0 ? void 0 : _b.length
            : (_c = carlineGroupData === null || carlineGroupData === void 0 ? void 0 : carlineGroupData.selectedFilter) === null || _c === void 0 ? void 0 : _c.length;
        return amountSelectedFilters || 0;
    }, [filterData]);
    const handleChange = () => {
        return handleChangeAllCarlineModels(applyFilters, filterData, carlineGroupCheckboxMembers, allCarlineModelsAreChecked, setAllCarlineModelsAreChecked, carlineGroup, carlineGroupName, filterCategory);
    };
    const countAllCarsOfCarline = () => {
        let totalCarsInCarline = 0;
        const checkboxFiltersData = context.filterData.groups;
        carlineGroupItems === null || carlineGroupItems === void 0 ? void 0 : carlineGroupItems.forEach((carlineGroupItem) => {
            const checkboxFilterData = checkboxFiltersData.carline.members[carlineGroupItem.itemHeadline];
            totalCarsInCarline += checkboxFilterData === null || checkboxFilterData === void 0 ? void 0 : checkboxFilterData.count;
        });
        return formatCount(totalCarsInCarline, locale).toString();
    };
    const accordionSectionPanelProps = {
        ref: panelRef,
        open,
        id: panelId,
    };
    return (React.createElement(DynamicThemeProviderWrapper, null,
        React.createElement(ModelFilterAccordionSectionContent, { ref: sectionRef, open: open },
            React.createElement(StyledButton, { type: "button", id: carlineGroupName, "aria-controls": panelId, "aria-expanded": open, open: open, nthChild: nthChild, onClick: handleToggle, onKeyDown: onKeyDown, ref: toggleRef },
                React.createElement(ModelImage, { carlineGroup: carlineGroup, carlineGroupPhoto: carlineGroupPhoto, carlineGroupPhotoNotAvailableText: carlineGroupPhotoNotAvailableText, open: open }),
                React.createElement(TextWrapper, { nthChild: nthChild },
                    React.createElement(Wrapper, null,
                        React.createElement(CarlineGroupAndAmountWrapper, null,
                            React.createElement(Text, { tag: "span", variant: {
                                    order: '1',
                                    style: 'bold',
                                    type: 'copy',
                                } }, i18nCarlineGroupName),
                            ' ',
                            React.createElement(Text, { tag: "span", variant: {
                                    order: '1',
                                    style: 'normal',
                                    type: 'copy',
                                } },
                                "(",
                                countAllCarsOfCarline(),
                                ")")),
                        React.createElement(StyledIcon, { name: "arrow-down", size: "s", open: open })),
                    React.createElement(StyledText, null,
                        carlineGroupCheckboxMembers.length,
                        " ",
                        modelsLabel)),
                countSelectedCars() > 0 && (React.createElement(React.Fragment, null,
                    React.createElement(DynamicComponent, { legacy: React.createElement(ChosenModelsWrapper, { open: open, nthChild: nthChild },
                            React.createElement(StyledIconSelect, { name: "select", size: "s" }),
                            React.createElement(Text, { tag: "span", variant: {
                                    order: '2',
                                    style: 'normal',
                                    type: 'copy',
                                } },
                                countSelectedCars(),
                                ' ',
                                countSelectedCars() > 1 ? chosenModelsLabel : chosenModelLabel)) }),
                    React.createElement(DynamicComponent, { alpha: React.createElement(StyledTag, { open: open, size: "sm", variant: "read-only", label: `${countSelectedCars()} ${countSelectedCars() > 1 ? chosenModelsLabel : chosenModelLabel}`, icon: "select" }) })))),
            React.createElement(ModelFilterAccordionSectionPanel, Object.assign({}, accordionSectionPanelProps),
                React.createElement(ModelFilterAccordionSectionPanelContent, { ref: contentRef, nthChild: nthChild, open: open },
                    React.createElement(AllModelsCheckbox, { id: `checkbox${carlineGroup}_${visibleIn}`, label: `${carlineGroupName} (${countAllCarsOfCarline()})`, value: `checkbox${carlineGroup}_${visibleIn}`, name: `checkbox${carlineGroup}_${visibleIn}`, checked: allCarlineModelsAreChecked, disabled: countAllCarsOfCarline() === '0', onChange: handleChange }),
                    React.createElement(CarlineGroupCheckboxes, { layoutWidth: layoutWidth }, carlineGroupCheckboxMembers.map((carlineGroupMember) => {
                        const checkboxLabel = carlineNames === null || carlineNames === void 0 ? void 0 : carlineNames[carlineGroupMember];
                        const checkboxData = group.items.find((object) => object.itemHeadline === carlineGroupMember);
                        if (checkboxData && checkboxLabel) {
                            return (React.createElement(CheckboxSimple, { groupHeadline: "carline", visibleIn: visibleIn, filterCategory: filterCategory, itemHeadline: checkboxData.itemHeadline, itemText: checkboxLabel.text, key: checkboxData.itemHeadline }));
                        }
                        return null;
                    })))))));
};
export default ModelFilterAccordionSection;
const StyledIconSelect = styled((props) => React.createElement(Icon, Object.assign({}, props))) `
  margin-right: var(--spacing-relative-xs);
  color: ${dynamicStylingHelper(SYS_COLOR_SURFACE_NEUTRAL_100_LIGHT, SYS_COLOR_SURFACE_NEUTRAL_100_DARK)};
`;
const StyledTag = styled((props) => React.createElement(Tag, Object.assign({}, props))) `
  margin-top: 24px;
  display: ${(props) => (props.open ? 'none' : 'inline-flex')};
  float: left;

  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    margin-left: ${SYS_SPACE_FIXED_200};
  }
`;
